import { createSlice } from "@reduxjs/toolkit";

const vodSlice = createSlice({
    name: 'vod',
    initialState: {},
    reducers: {}
})

export default vodSlice.reducer;
export const { } = vodSlice.actions